export const API_ROUTES = {
  LOGIN: "/auth/user-login",
  LOGOUT: "/auth/logout",
  FORGOT_PASSWORD: "/auth/forgot-password",
  INSTANCES: "/instances",
  FEEDBACK: "/feedback",
  CONVERSATION: "/conversation",
  IMAGEURL: "/get-media",
  TABLEDATA:"/get-table-data"
};
